import React, { useMemo } from 'react'

import { Box, BoxProps } from '../Box/Box'

type Props = BoxProps
export const Dot = (props: Props) => {
    const { style, ...boxProps } = props
    const compoundStyle = useMemo(() => {
        return {
            boxShadow: `0 0 0px 2px var(--background)`,
            ...style,
        }
    }, [style])
    return (
        <Box width="x1" height="x1" rounded="full" style={compoundStyle} {...boxProps}>
            <Box
                className={props.className}
                width="100%"
                height="100%"
                background="accent"
                rounded="full"
            />
        </Box>
    )
}
